/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: temporary-file-upload-resource-factory
 *
 * Created by kyang on 3/1/21.
 */

angular
    .module('prism-ui.components.data')
    .factory('TemporaryFileUploadResourceFactory', ($resource: JS5Function, EndPointService: JS5Object) => {
        return $resource(
            `${EndPointService.temporaryFileUploadEndpoint}`,
            {},
            {
                getConfiguration: {
                    method: 'GET',
                    url: `${EndPointService.temporaryFileUploadEndpoint}/configuration`,
                    params: {
                        name: '@name',
                        destinationPath: '@destinationPath',
                    }
                },
                getTemporaryUploadCredentials: {
                    method: 'GET',
                    url: `${EndPointService.temporaryFileUploadEndpoint}/upload-credentials`,
                    params: {
                        name: '@name',
                        destinationPath: '@destinationPath',
                    }
                },
            });
    });
